import Annotations from './timeline-annotations';
import Stories from './timeline-stories';

const timeline = Stories.concat(Annotations);

export default timeline;


// WEBPACK FOOTER //
// ./src/data/timeline.js